import { api } from '@/config/api';

export interface StatusAdMedia { fileId: string; url: string; type: 'image' | 'video'; headline?: string }
export interface StatusAdInput {
  requestId: string; metaAccountUid: string; name: string; pageId: string; whatsappAccountUid?: string;
  objective: string; optimizationGoal: string; destination: 'WEBSITE' | 'WHATSAPP'; websiteUrl?: string;
  dailyBudgetMinor: number; countries: string[]; userAgeUnknown: boolean; message: string; headline: string;
  media: StatusAdMedia[]; videoCover?: StatusAdMedia; pixelId?: string; conversionEvent?: string; saveDraftOnly?: boolean;
}
export interface StatusAdDraft {
  draftUid: string; name: string; currency: string; status: 'DRAFT' | 'CREATING' | 'FAILED' | 'PAUSED' | 'ACTIVE'; input: StatusAdInput;
  campaignId?: string; adSetId?: string; creativeId?: string; adId?: string; stage?: string; lastError?: string; resultUncertain: boolean; effectiveStatus?: string;
  dailyInsights: Array<{ date_start?: string; publisher_platform?: string; impressions?: string; clicks?: string; spend?: string }>;
  syncedAt?: string;
}
export interface StatusAdOptions {
  accounts: Array<{ accountUid: string; adAccountId: string; adAccountName: string; currency: string; isDefault?: boolean; pageId?: string; pageIds?: string[]; instagramAccountId?: string }>;
  numbers: Array<{ accountUid: string; businessName: string; displayPhoneNumber: string; profilePicUrl?: string }>;
  goals: Record<string, string[]>; apiVersion: string;
}
const BASE = '/slighter_crm/whatsapp-ads';
export const whatsappStatusAdsService = {
  options: async (): Promise<StatusAdOptions> => (await api.get(`${BASE}/options`)).data,
  identities: async (account: string): Promise<{ pages: Array<{ id: string; name: string }>; instagramAccountId?: string }> => (await api.get(`${BASE}/identities`, { params: { account } })).data,
  list: async (account?: string): Promise<StatusAdDraft[]> => (await api.get(BASE, { params: { account } })).data,
  create: async (input: StatusAdInput): Promise<StatusAdDraft> => (await api.post(BASE, input, { timeout: 240000 })).data,
  submit: async (uid: string): Promise<StatusAdDraft> => (await api.post(`${BASE}/${uid}/submit`, {}, { timeout: 240000 })).data,
  sync: async (uid: string): Promise<StatusAdDraft> => (await api.post(`${BASE}/${uid}/sync`)).data,
  preview: async (uid: string): Promise<{ url: string }> => (await api.get(`${BASE}/${uid}/preview`)).data,
};
